import { render, staticRenderFns } from "./ModalTableEvents.vue?vue&type=template&id=39f02116"
import script from "./ModalTableEvents.vue?vue&type=script&lang=js"
export * from "./ModalTableEvents.vue?vue&type=script&lang=js"
import style0 from "./ModalTableEvents.vue?vue&type=style&index=0&id=39f02116&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports